<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="fields" [formGroup]="rateLimitForm">
    <div *ngIf="success || error">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="field">
      <span>Profile Name</span>
      <input
        type="text"
        name=""
        id=""
        placeholder="Enter profile"
        formControlName="profileName"
      />
    </div>

    <div class="field">
      <span>Requests</span>
      <input
        type="text"
        name=""
        id=""
        placeholder="Enter requests"
        formControlName="requests"
      />
    </div>

    <div class="field">
      <span>Time Interval (Seconds) </span>
      <input
        type="text"
        name=""
        id=""
        placeholder="Enter time interval"
        formControlName="timeInterval"
      />
    </div>

    <div class="field">
      <span>Response </span>
      <textarea
        name=""
        id=""
        placeholder="Enter response"
        formControlName="response"
      ></textarea>
    </div>
  </div>
</div>

<div
  class="actions"
  style="background-color: inherit !important; border: none !important"
>
  <button
    class="ui basic primary button"
    (click)="modal.deny(undefined)"
    style="border-radius: 8px !important"
  >
    Cancel
  </button>
  <button
    class="ui basic primary button save-button"
    style="border-radius: 8px !important"
    (click)="add()"
    [class.loading]="pending"
  >
    Save
  </button>
</div>
